"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NdcBarcodeScan = void 0;
const core_1 = require("@material-ui/core");
const icons_1 = require("client/components/icons");
const button_1 = require("client/components/material/button");
const list_1 = require("client/components/material/list");
const list_item_1 = require("client/components/material/list/list-item");
const list_item_text_1 = require("client/components/material/list/list-item/list-item-text");
const modal_1 = require("client/components/modal");
const material_ui_1 = require("material-ui");
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const ramda_1 = require("ramda");
const React = require("react");
const react_barcode_reader_1 = require("react-barcode-reader");
const moment = require("moment");
const styles = core_1.createStyles({
    rowDetails: {
        padding: "12px 16px",
        flex: "1 0 120px"
    },
    rowDetailsContainer: {
        display: "flex",
        alignItems: "center"
    },
    rowItem: {},
    listRow: {
        display: "flex",
        justifyContent: "space-between"
    },
    submitContainer: {
        display: "flex",
        justifyContent: "flex-end",
        marginTop: "10px"
    },
    divider: {
        height: "50px",
        borderRight: "solid 1px #e5e5e5",
        margin: "0px 10px"
    },
    invalid: {
        background: "rgba(193, 30, 30, 0.05)"
    },
    invalidMessage: {
        marginTop: "15px",
        color: "red"
    }
});
const decorate = core_1.withStyles(styles);
let NdcBarcodeScanUnstyled = class NdcBarcodeScanUnstyled extends React.Component {
    constructor() {
        super(...arguments);
        this.scannedData = [];
        this.normalizeData = (data, field) => {
            let parsedData = data;
            if (field === "ndc") {
                const dataSubstring = [];
                dataSubstring.push(parsedData.substring(0, 5));
                dataSubstring.push(parsedData.substring(5, 9));
                dataSubstring.push(parsedData.substring(9, parsedData.length));
                parsedData = dataSubstring.join("-");
            }
            if (field === "exp") {
                const dateFormats = ["YYMMDD", "YYYYMMDD"];
                parsedData = moment(parsedData, dateFormats).format("MM-DD-YYYY");
            }
            return parsedData;
        };
        // TODO: UPDATE parse barcode algorithm.
        /*
          Expecting
            order: ndc serial exp lot
            facts:
              ndc first 16 digits including prefixes
              exp in YYMMDD format
        */
        this.parseBarcode = (barcodeData) => {
            const stripPunctuations = (value) => {
                const re = /[^\d\w]/g;
                return value.replace(re, "");
            };
            const reg = /\s+/g;
            let extractedData = stripPunctuations(barcodeData).replace(reg, "");
            let ndcRaw = "";
            let serialRaw = "";
            let expRaw = "";
            let lotRaw = "";
            /* ndc */
            ndcRaw = extractedData.substring(0, 16);
            extractedData = extractedData.replace(ndcRaw, "");
            /* serial */
            const indexOf17 = extractedData.indexOf("17");
            serialRaw = extractedData.substring(0, indexOf17);
            extractedData = extractedData.replace(serialRaw, "");
            /* exp */
            let indexOf10 = extractedData.indexOf("10");
            let numAttempt = 0;
            while (expRaw.length < 8 && numAttempt < 10) {
                numAttempt++;
                indexOf10 = extractedData.indexOf("10");
                if (indexOf10 === 0) {
                    indexOf10 = extractedData.indexOf("10", indexOf10 + 1);
                }
                expRaw = expRaw.concat(extractedData.substring(0, indexOf10));
                extractedData = extractedData.replace(extractedData.substring(0, indexOf10), "");
            }
            /* lot */
            lotRaw = extractedData.substring(0);
            const ndc = ndcRaw ? ndcRaw.substring(5) : "";
            const serial = serialRaw ? serialRaw.substring(2) : "";
            const lot = lotRaw ? lotRaw.substring(2) : "";
            const exp = expRaw ? expRaw.substring(2) : "";
            return {
                rawData: barcodeData,
                ndc: this.normalizeData(ndc, "ndc"),
                serial: this.normalizeData(serial),
                lot: this.normalizeData(lot),
                exp: this.normalizeData(exp, "exp")
            };
        };
        this.normalizeBarcodeList = () => {
            const barcodeList = this.scannedData.map((data) => this.parseBarcode(data));
            return barcodeList;
        };
        this.handleRemoveItem = (barcodeData) => () => {
            const foundIndex = this.scannedData.indexOf(barcodeData.rawData);
            if (foundIndex !== null) {
                this.scannedData.splice(foundIndex, 1);
            }
            else {
                throw new Error("Error deleting from scanned list. Index of deleted item not found.");
            }
        };
        this.renderBarcodeDetails = (ndcScan) => {
            const { rawData, ndc = "", serial = "", lot = "", exp = "" } = ndcScan[1][0];
            const outputRawData = !ndc && !serial && !lot && !exp;
            return (React.createElement("div", { className: this.props.classes.rowDetailsContainer },
                React.createElement("div", { className: this.props.classes.rowDetails },
                    outputRawData ? React.createElement(material_ui_1.Typography, null,
                        "Raw data: ",
                        rawData) : null,
                    React.createElement(material_ui_1.Typography, null,
                        "NDC: ",
                        ndc),
                    React.createElement(material_ui_1.Typography, null,
                        "SERIAL: ",
                        serial),
                    React.createElement(material_ui_1.Typography, null,
                        "LOT: ",
                        lot),
                    React.createElement(material_ui_1.Typography, null,
                        "EXP: ",
                        exp)),
                this.props.renderPreview ? this.props.renderPreview(ndcScan) : null));
        };
        this.renderRow = (row, index) => {
            const [, barcodeDatas] = row;
            const { rawData, ndc, serial, lot, exp } = barcodeDatas[0];
            const outputRawData = !ndc && !serial && !lot && !exp;
            const timesItemScanned = barcodeDatas.length;
            return (React.createElement("div", { key: index, className: this.props.classes.rowItem },
                React.createElement(list_item_1.MaterialListItem, null,
                    React.createElement(list_item_text_1.MaterialListItemText, { primary: `${outputRawData ? rawData : ndc} x ${timesItemScanned}` }),
                    React.createElement(list_item_text_1.MaterialListItemText, { onClick: this.handleRemoveItem(barcodeDatas[0]), primary: React.createElement(icons_1.DeleteIcon, null) })),
                React.createElement(material_ui_1.Collapse, { in: true }, this.renderBarcodeDetails(row))));
        };
        this.generateScannedList = () => {
            const list = this.normalizeBarcodeList();
            const byNdc = ramda_1.groupBy((data) => {
                if (data.ndc) {
                    return data.ndc;
                }
                return data.rawData;
            });
            const listByNdc = Object.entries(byNdc(list));
            return listByNdc;
        };
        this.handleSubmit = () => {
            const scannedList = this.generateScannedList();
            this.props.onSubmit(scannedList);
        };
        this.handleBarcodeReaderError = (err) => console.error("Error Scanning barcode", err);
        this.handleScan = (data) => {
            this.scannedData.push(data);
            if (this.props.autoSubmit) {
                this.handleSubmit();
                this.props.onCancel();
            }
        };
    }
    get scannedList() {
        if (!this.scannedData.length) {
            return React.createElement(material_ui_1.Typography, null, "List is empty");
        }
        return (React.createElement("div", { className: "barcode-scan-modal-list" },
            React.createElement(list_1.MaterialList, { columns: [
                    { id: "NO_ACTION", label: "Data" },
                    { id: "NO_ACTION", label: `(${this.scannedData.length})` }
                ], rows: this.generateScannedList(), renderRow: this.renderRow }),
            React.createElement("div", { className: this.props.classes.submitContainer },
                React.createElement(button_1.MaterialButton, { onClick: this.handleSubmit }, "submit"))));
    }
    render() {
        return (React.createElement(modal_1.AssetModal, { title: `Barcode Scan`, onCancel: this.props.onCancel },
            React.createElement("div", null,
                React.createElement(react_barcode_reader_1.default, { onError: this.handleBarcodeReaderError, onScan: this.handleScan, timeBeforeScanTest: 200, stopPropagation: true, preventDefault: true }),
                React.createElement(material_ui_1.Typography, { align: "center", variant: "subheading", gutterBottom: true }, "Scan barcode to populate list."),
                React.createElement("div", null,
                    React.createElement(material_ui_1.Typography, { variant: "subheading" }, "Scanned List"),
                    this.scannedList))));
    }
};
__decorate([
    mobx_1.observable
], NdcBarcodeScanUnstyled.prototype, "scannedData", void 0);
__decorate([
    mobx_1.computed
], NdcBarcodeScanUnstyled.prototype, "scannedList", null);
NdcBarcodeScanUnstyled = __decorate([
    mobx_react_1.observer
], NdcBarcodeScanUnstyled);
exports.NdcBarcodeScan = decorate(NdcBarcodeScanUnstyled);



//////////////////
// WEBPACK FOOTER
// ./src/client/components/ndc-barcode-scan/ndc-barcode-scan.tsx
// module id = 3577
// module chunks = 0